/* Lance cart-only runtime. Shopify Ajax Cart remains the source of truth. */
(function () {
  'use strict';

  var CFG = window.LANCE_CFG || {};
  var tierData = {};
  try {
    var tierElement = document.querySelector('[data-lance-cart-tiers]');
    if (tierElement) tierData = JSON.parse(tierElement.textContent);
  } catch (error) { /* No verified offer data means no tier claim. */ }

  function offerGuidance(item) {
    var tiers = tierData[String(item.product_id)];
    var expected = [[1, 0], [2, 5], [6, 10], [12, 12], [24, 15]];
    if (!Array.isArray(tiers) || tiers.length !== expected.length || !tiers.every(function (tier, index) {
      return tier && tier.min === expected[index][0] && tier.discount_pct === expected[index][1];
    })) return '';
    var firstDiscount = tiers.find(function (tier) { return tier.discount_pct > 0; });
    return 'Eligible quantity savings start at ' + firstDiscount.min + ' units (' + firstDiscount.discount_pct + '%). The applied cart discount reflects eligible tools combined.';
  }
  var routes = {
    collection: CFG.collectionUrl || '/collections/shop-all',
    cart: CFG.cartUrl || '/cart',
    cartChange: CFG.cartChangeUrl || '/cart/change'
  };
  var families = [
    { tag: '01', color: '#2038E8' },
    { tag: '02', color: '#FF4B00' },
    { tag: '03', color: '#C6EF1F' },
    { tag: '04', color: '#FF3D9A' },
    { tag: '05', color: '#6E30F2' },
    { tag: '06', color: '#FFC400' },
    { tag: '07', color: '#F2EFE4' }
  ];

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function sizedImage(url, width) {
    if (!url || url.indexOf('cdn.shopify.com') === -1 || /[?&]width=/.test(url)) return url || '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function jsonRoute(url) {
    return /\.js(?:$|\?)/.test(url) ? url : url + '.js';
  }

  function responseJSON(response) {
    return response.json().catch(function () { return {}; }).then(function (data) {
      if (!response.ok) throw new Error(data.description || data.message || 'Shopify could not update the cart.');
      return data;
    });
  }

  function paintCount(cart) {
    document.querySelectorAll('[data-lz-cart-count]').forEach(function (element) {
      element.textContent = Number(cart.item_count) || 0;
    });
  }

  function fetchCart() {
    return fetch(jsonRoute(routes.cart), {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(responseJSON).then(function (cart) {
      paintCount(cart);
      return cart;
    });
  }

  function changeLine(key, quantity) {
    return fetch(jsonRoute(routes.cartChange), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity) || 0) })
    }).then(responseJSON).then(function (cart) {
      paintCount(cart);
      return cart;
    });
  }

  function familyFor(item) {
    var text = ((item.product_type || '') + ' ' + (item.product_title || '')).toLowerCase();
    if (/t-square/.test(text)) return families[1];
    if (/l-square/.test(text)) return families[2];
    if (/curve/.test(text)) return families[3];
    if (/triangle/.test(text)) return families[4];
    if (/cuff|center|agate|pica|special/.test(text)) return families[5];
    if (/black|anodized/.test(text)) return { tag: '07', color: '#131313' };
    return families[0];
  }

  function lineModel(item) {
    return {
      item: item,
      family: familyFor(item),
      url: item.url || routes.collection,
      image: item.image || '',
      title: item.product_title || item.title || 'Lance instrument',
      variantTitle: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
      sku: item.sku || '',
      each: item.final_price == null ? item.price : item.final_price,
      total: item.final_line_price == null ? item.line_price : item.final_line_price
    };
  }

  function renderCart(root) {
    var paintedSignature = null;
    function paint(cart) {
      var signature = JSON.stringify([cart.currency, cart.total_price, (cart.items || []).map(function (item) { return [item.key, item.quantity]; })]);
      if (paintedSignature !== null && signature !== paintedSignature) document.dispatchEvent(new CustomEvent('lance:cart-updated'));
      paintedSignature = signature;
      var lines = (cart.items || []).map(lineModel);
      var count = Number(cart.item_count) || 0;
      var subtotal = Number(cart.total_price) || 0;
      var currency = cart.currency || 'USD';
      var heading = '<div style="display:flex;align-items:flex-end;justify-content:space-between;gap:16px;flex-wrap:wrap;margin-bottom:26px;">' +
        '<h1 class="bric" style="font-size:clamp(38px,5.4vw,68px);line-height:.96;letter-spacing:-.015em;margin:0;">Your cart<span style="color:#2038E8;">.</span></h1>' +
        '<span class="mono" style="font-size:11px;letter-spacing:.16em;color:#6B675C;">' + count + (count === 1 ? ' ITEM' : ' ITEMS') + ' · PRICES RESOLVE FROM LIVE VARIANTS</span></div>';

      if (!lines.length) {
        root.innerHTML = heading + '<div style="border:3px dashed #131313;background:#FFFFFF;padding:56px 24px;text-align:center;">' +
          '<div class="mono" style="font-size:12px;letter-spacing:.2em;color:#6B675C;">READING</div>' +
          '<div class="bric" style="font-size:clamp(44px,7vw,84px);line-height:1;margin:6px 0 10px;">0.000<span style="color:#FF3D9A;">″</span></div>' +
          '<p style="margin:0 auto;max-width:420px;font-size:15.5px;line-height:1.55;color:#4A473C;">Nothing on the bench yet. The instruments are hanging on the wall, measured and waiting.</p>' +
          '<a href="' + routes.collection + '" class="lz-btn lz-btn-dark" style="margin-top:22px;padding:14px 26px;font-size:15px;">Explore the Tool Wall</a></div>';
        return;
      }

      root.innerHTML = heading + '<div class="lz-cart-grid"><div style="display:flex;flex-direction:column;gap:14px;">' +
        lines.map(function (line) {
          return '<article class="lz-cart-line">' +
            '<span aria-hidden="true" style="width:10px;background:' + line.family.color + ';flex:none;display:block;"></span>' +
            '<div class="lz-cart-image">' +
            (line.image ? '<img src="' + esc(sizedImage(line.image, 320)) + '" alt="' + esc(line.title) + '" width="320" height="320" loading="lazy" decoding="async" style="max-width:100%;max-height:104px;object-fit:contain;display:block;">' : '') + '</div>' +
            '<div style="flex:1;min-width:0;padding:14px 16px;display:flex;flex-direction:column;gap:5px;">' +
            '<span class="mono" style="font-size:9.5px;letter-spacing:.16em;color:#6B675C;">FAMILY ' + line.family.tag + ' · SKU ' + esc(line.sku) + '</span>' +
            '<a href="' + esc(line.url) + '" style="font-weight:700;font-size:16.5px;color:#131313;text-decoration:none;line-height:1.2;">' + esc(line.title) + '</a>' +
            '<span class="mono" style="font-size:11.5px;letter-spacing:.08em;color:#3A372E;">' + esc(line.variantTitle) + '</span>' +
            (offerGuidance(line.item) ? '<span style="font-size:12px;line-height:1.5;">' + esc(offerGuidance(line.item)) + '</span>' : '') +
            '<div style="display:flex;align-items:center;gap:14px;margin-top:auto;padding-top:8px;flex-wrap:wrap;">' +
            '<div class="lz-qty"><button data-lz-change="' + esc(line.item.key) + '" data-lz-quantity="' + Math.max(0, line.item.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + line.item.quantity + '</span><button data-lz-change="' + esc(line.item.key) + '" data-lz-quantity="' + (line.item.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
            '<a href="#" data-lz-change="' + esc(line.item.key) + '" data-lz-quantity="0" style="font-size:12.5px;font-weight:600;color:#6B675C;text-decoration:underline;text-decoration-thickness:2px;">Remove</a>' +
            (line.item.original_line_price > line.total ? '<span class="mono" style="font-size:9.5px;letter-spacing:.1em;background:#C6EF1F;color:#131313;padding:3px 8px;">DISCOUNT APPLIED</span>' : '') + '</div></div>' +
            '<div class="lz-cart-line-price">' +
            '<span class="bric" style="font-size:20px;">' + money(line.total, currency) + '</span><span class="mono" style="font-size:10px;color:#8F8B7E;">' + money(line.each, currency) + ' EACH</span></div></article>';
        }).join('') +
        '<div style="display:flex;align-items:center;gap:12px;border:2px solid #131313;background:#FFD500;padding:11px 16px;"><span aria-hidden="true" style="width:11px;height:11px;background:#131313;flex:none;display:block;"></span><span style="font-size:13px;font-weight:600;line-height:1.45;">Eligible quantity discounts apply automatically and are included in the totals shown here. Each product page lists its current tiers. <a href="' + (CFG.proUrl || '#') + '" style="color:#131313;font-weight:700;">Need a company quote? →</a></span></div></div>' +
        '<aside style="background:#FFFFFF;border:3px solid #131313;position:sticky;top:96px;"><div aria-hidden="true" style="display:flex;height:8px;">' + families.map(function (family) { return '<span style="flex:1;background:' + family.color + ';display:block;"></span>'; }).join('') + '</div>' +
        '<div style="padding:20px;display:flex;flex-direction:column;gap:12px;"><span class="mono" style="font-size:10.5px;letter-spacing:.18em;color:#6B675C;">ORDER SUMMARY</span>' +
        '<div style="display:flex;justify-content:space-between;font-size:14.5px;"><span>Subtotal</span><span style="font-weight:700;">' + money(subtotal, currency) + '</span></div>' +
        '<div style="display:flex;justify-content:space-between;font-size:14.5px;color:#4A473C;"><span>Shipping</span><span class="mono" style="font-size:11px;letter-spacing:.06em;">AT CHECKOUT</span></div>' +
        '<div style="display:flex;justify-content:space-between;font-size:14.5px;color:#4A473C;"><span>Taxes</span><span class="mono" style="font-size:11px;letter-spacing:.06em;">AT CHECKOUT</span></div>' +
        '<div style="display:flex;justify-content:space-between;align-items:baseline;border-top:3px solid #131313;padding-top:12px;"><span style="font-weight:700;font-size:15px;">Estimated total</span><span class="bric" style="font-size:26px;">' + money(subtotal, currency) + '</span></div>' +
        '<form action="' + esc(routes.cart) + '" method="post"><button type="submit" name="checkout" class="lz-btn lz-btn-dark" style="width:100%;padding:16px;font-size:16px;">Check out — ' + money(subtotal, currency) + '</button></form>' +
        '<a href="#shipping-estimate" style="font-size:14px;font-weight:700;color:#131313;">Estimate shipping before checkout</a>' +
        '<a href="' + routes.collection + '" style="text-align:center;font-size:13.5px;font-weight:700;color:#131313;text-decoration:underline;text-decoration-thickness:2px;text-decoration-color:#FF3D9A;">Continue shopping</a>' +
        '<span class="mono" style="font-size:9.5px;letter-spacing:.1em;color:#8F8B7E;text-align:center;">ALL MAJOR CARDS · SHOP PAY · PAYPAL · POs FOR PRO</span></div></aside></div>';

      root.querySelectorAll('[data-lz-change]').forEach(function (button) {
        button.onclick = function (event) {
          event.preventDefault();
          button.disabled = true;
          changeLine(button.getAttribute('data-lz-change'), button.getAttribute('data-lz-quantity'))
            .then(paint)
            .catch(function (error) {
              button.disabled = false;
              window.alert(error.message || 'Shopify could not update the cart.');
            });
        };
      });
    }

    root.innerHTML = '<div class="mono" role="status" style="padding:44px 0;letter-spacing:.14em;">READING LIVE SHOPIFY CART…</div>';
    fetchCart().then(paint).catch(function (error) {
      root.innerHTML = '<div role="alert" style="border:3px solid #131313;background:#FFFFFF;padding:32px;"><h1 class="bric" style="margin:0 0 10px;">The cart could not be read.</h1><p>' + esc(error.message || 'Refresh and try again.') + '</p><a class="lz-btn lz-btn-dark" href="' + esc(routes.cart) + '">Reload cart</a></div>';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var cart = document.querySelector('[data-lz-cart]');
    if (cart) renderCart(cart);
  });
})();
